import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../shared/data.service";
import { VisitorTableRequest } from "../shared/VisitorTableRequest";
import * as moment from "moment";
import { LocalstorageService } from "../../../../shared";

@Component({
	selector: "caass-ms-visitor-selector",
	templateUrl: "./ms-visitor-selector.component.html",
	styleUrls: ["./ms-visitor-selector.component.css"],
})
export class MsVisitorSelectorComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationViewVisitors, private localService: LocalstorageService) {}

	ngOnInit(): void {
		//
		//	10.15 Try to select a facility based on the last school that was selected
		//
		var lastSchool = this.localService.getItem("SchoolSelector_School");
		if (lastSchool != undefined && lastSchool.SchoolID != undefined) {
			this.LastSchoolID = lastSchool.SchoolID;
		}

		this.loadLists();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	@Output() VisitorChanged: EventEmitter<any> = new EventEmitter();
	errorMessage: any = "";

	LastSchoolID: number = -1;

	/////////////////////////////
	// Right Col, Filter
	/////////////////////////////

	FiltersLoading: boolean = false;
	Facility: any;
	lstFacility: any = [];

	VisitorStatus: any;
	lstVisitorStatus: any = [];

	VisitorType: any;
	lstVisitorType: any = [];

	VisitorReason: any;
	lstVisitorReason: any = [];

	InFacility: any;
	lstInFacility = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Yes",
		},
		{
			ID: 0,
			Desc: "No",
		},
	];

	DateRangeOption: any;
	lstDateRangeOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 0,
			Desc: "Today",
		},
		{
			ID: 30,
			Desc: "Last Month",
		},
		{
			ID: 60,
			Desc: "Last 2 Months",
		},
		{
			ID: 90,
			Desc: "Last 3 Months",
		},
		{
			ID: -2,
			Desc: "Current School Year",
		},
		{
			ID: -3,
			Desc: "Custom Range",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	FilterText: string = "";

	/////////////////////////////

	/////////////////////////////
	// Middle Col, Table
	/////////////////////////////

	TableLoading: boolean = false;
	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedVisitor: any;
	lstVisitor: any;

	lstFilterVisitorTypeDesc: any = [];
	lstFilterVisitorStatusDesc: any = [];
	lstFilterInFacilityDesc: any = [];
	lstFilterHasPassDesc: any = [];
	lstFilterWaitingForVerifiedDesc: any = [];
	lstFilterConfirmedOffenderDesc: any = [];

	/////////////////////////////

	/////////////////////////////
	// Right Col, Extended Info
	/////////////////////////////

	VisitorLoading: boolean = false;

	VisitorImage: string = "";
	VisitorNotes: string = "N/A";
	VisitorLastPassDate: string = "N/A";
	VisitorLastFacility: string = "N/A";
	VisitorLastFacilityLocation: string = "N/A";

	/////////////////////////////

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadLists() {
		this.FiltersLoading = true;

		var result = this.visitorService.VisitorSelectorFilterInfoSelectList(this.LastSchoolID);
		result.subscribe(
			(response: any) => {
				if (response != null) {
					if (response.lstFacility != null) {
						this.lstFacility = response.lstFacility;

						this.lstFacility.unshift({
							FacilityID: -1,
							FacilityName: "All",
						});

						this.Facility = this.lstFacility[0];

						for (var z = 0; z < this.lstFacility.length; z++) {
							var next = this.lstFacility[z];

							if (next.Selected == true) {
								this.Facility = next;
							}
						}
					}

					if (response.lstVisitorStatus != null) {
						this.lstVisitorStatus = response.lstVisitorStatus;

						this.lstVisitorStatus.unshift({
							VisitorStatusID: -1,
							VisitorStatusDesc: "All",
							AllowAdmittance: 1,
						});

						this.VisitorStatus = this.lstVisitorStatus[0];
					}

					if (response.lstVisitorType != null) {
						this.lstVisitorType = response.lstVisitorType;

						this.lstVisitorType.unshift({
							VisitorTypeID: -1,
							VisitorTypeDesc: "All",
						});

						this.VisitorType = this.lstVisitorType[0];
					}

					if (response.lstVisitorReason != null) {
						this.lstVisitorReason = response.lstVisitorReason;

						this.lstVisitorReason.unshift({
							VisitorReasonID: -1,
							VisitorReasonDesc: "All",
						});

						this.VisitorReason = this.lstVisitorReason[0];
					}

					this.InFacility = this.lstInFacility[0];
					this.DateRangeOption = this.lstDateRangeOption[0];
				}

				this.FiltersLoading = false;
			},
			(error) => {
				this.FiltersLoading = false;
			}
		);
	}

	loadTable() {
		this.errorMessage = "";

		this.TableLoading = true;

		var fsDate = "";
		var feDate = "";

		if (this.DateRangeOption.ID == -3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");
		}

		var parms: VisitorTableRequest = {
			FacilityID: this.Facility.FacilityID,
			VisitorStatusID: this.VisitorStatus.VisitorStatusID,
			VisitorTypeID: this.VisitorType.VisitorTypeID,
			VisitorReasonID: this.VisitorReason.VisitorReasonID,
			InFacility: this.InFacility.ID,
			DateRangeOption: this.DateRangeOption.ID,
			StartDate: fsDate,
			EndDate: feDate,
			FilterText: this.FilterText,
		};

		var result = this.visitorService.VisitorTableSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstVisitor = response;

				//Load Data Filter Lists
				this.lstFilterVisitorTypeDesc = Array.from(new Set(this.lstVisitor.map((item: any) => item.VisitorTypeDesc))).sort();
				this.lstFilterVisitorStatusDesc = Array.from(new Set(this.lstVisitor.map((item: any) => item.VisitorStatusDesc))).sort();
				this.lstFilterInFacilityDesc = Array.from(new Set(this.lstVisitor.map((item: any) => item.InFacilityDesc))).sort();
				this.lstFilterHasPassDesc = Array.from(new Set(this.lstVisitor.map((item: any) => item.HasPassDesc))).sort();
				this.lstFilterWaitingForVerifiedDesc = Array.from(new Set(this.lstVisitor.map((item: any) => item.WaitingForVerifiedDesc))).sort();
				this.lstFilterConfirmedOffenderDesc = Array.from(new Set(this.lstVisitor.map((item: any) => item.ConfirmedOffenderDesc))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	loadExtendedInfo() {
		if (this.SelectedVisitor == undefined) {
			this.VisitorChanged.emit(this.SelectedVisitor);
			return;
		}

		this.VisitorLoading = true;

		var result = this.visitorService.VisitorExtendedInfoSelect(this.SelectedVisitor.PersonID);
		result.subscribe(
			(response: any) => {
				this.VisitorImage = response.VisitorImage;
				this.VisitorNotes = response.VisitorNotes;
				this.VisitorLastPassDate = response.VisitorLastPassDate;
				this.VisitorLastFacility = response.VisitorLastFacility;
				this.VisitorLastFacilityLocation = response.VisitorLastFacilityLocation;

				this.VisitorLoading = false;

				this.VisitorChanged.emit(this.SelectedVisitor);
			},
			(error) => {
				this.VisitorLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////

	onSearch() {
		this.loadTable();
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	onRowSelect(val) {
		this.SelectedVisitor = val.data;
		this.loadExtendedInfo();
	}
	onRowUnselect(val) {
		this.SelectedVisitor = null;
		this.ClearVisitorData();

		this.VisitorChanged.emit(this.SelectedVisitor);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.FiltersLoading == true || this.TableLoading == true || this.VisitorLoading == true;
	}

	ClearVisitorData() {
		this.VisitorImage = "";
		this.VisitorNotes = "N/A";
		this.VisitorLastPassDate = "N/A";
		this.VisitorLastFacility = "N/A";
		this.VisitorLastFacilityLocation = "N/A";
	}

	/////////////////////////////////////////////////////////////////////////
}
